/**
 * @fileoverview gRPC-Web generated client stub for fleet
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as shared_pb from './shared_pb';

import {
  AlternateScheduleOrErrorResponse,
  GetLastTimeSlotOrErrorResponse,
  MaterializedScheduleOrErrorResponse,
  OperatingAreaDetails,
  OperatingAreaScheduleRequest,
  OperatingAreasAbbrevRequest,
  OperatingAreasOrErrorResponse,
  OperatingAreasRequest,
  RegularScheduleOrErrorResponse,
  RemoveRequest,
  SetAlternateScheduleRequest,
  SetRegularScheduleRequest,
  SiteWeatherForecast,
  SiteWeatherMap} from './site_pb';

export class SiteServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetSchedule = new grpcWeb.AbstractClientBase.MethodInfo(
    MaterializedScheduleOrErrorResponse,
    (request: OperatingAreaScheduleRequest) => {
      return request.serializeBinary();
    },
    MaterializedScheduleOrErrorResponse.deserializeBinary
  );

  getSchedule(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null): Promise<MaterializedScheduleOrErrorResponse>;

  getSchedule(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: MaterializedScheduleOrErrorResponse) => void): grpcWeb.ClientReadableStream<MaterializedScheduleOrErrorResponse>;

  getSchedule(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: MaterializedScheduleOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetSchedule',
        request,
        metadata || {},
        this.methodInfoGetSchedule,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetSchedule',
    request,
    metadata || {},
    this.methodInfoGetSchedule);
  }

  methodInfoGetRegularSchedule = new grpcWeb.AbstractClientBase.MethodInfo(
    RegularScheduleOrErrorResponse,
    (request: shared_pb.OperatingAreaRequest) => {
      return request.serializeBinary();
    },
    RegularScheduleOrErrorResponse.deserializeBinary
  );

  getRegularSchedule(
    request: shared_pb.OperatingAreaRequest,
    metadata: grpcWeb.Metadata | null): Promise<RegularScheduleOrErrorResponse>;

  getRegularSchedule(
    request: shared_pb.OperatingAreaRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: RegularScheduleOrErrorResponse) => void): grpcWeb.ClientReadableStream<RegularScheduleOrErrorResponse>;

  getRegularSchedule(
    request: shared_pb.OperatingAreaRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: RegularScheduleOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetRegularSchedule',
        request,
        metadata || {},
        this.methodInfoGetRegularSchedule,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetRegularSchedule',
    request,
    metadata || {},
    this.methodInfoGetRegularSchedule);
  }

  methodInfoSetRegularSchedule = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: SetRegularScheduleRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  setRegularSchedule(
    request: SetRegularScheduleRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  setRegularSchedule(
    request: SetRegularScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  setRegularSchedule(
    request: SetRegularScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/SetRegularSchedule',
        request,
        metadata || {},
        this.methodInfoSetRegularSchedule,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/SetRegularSchedule',
    request,
    metadata || {},
    this.methodInfoSetRegularSchedule);
  }

  methodInfoGetAlternateSchedule = new grpcWeb.AbstractClientBase.MethodInfo(
    AlternateScheduleOrErrorResponse,
    (request: OperatingAreaScheduleRequest) => {
      return request.serializeBinary();
    },
    AlternateScheduleOrErrorResponse.deserializeBinary
  );

  getAlternateSchedule(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null): Promise<AlternateScheduleOrErrorResponse>;

  getAlternateSchedule(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AlternateScheduleOrErrorResponse) => void): grpcWeb.ClientReadableStream<AlternateScheduleOrErrorResponse>;

  getAlternateSchedule(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: AlternateScheduleOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetAlternateSchedule',
        request,
        metadata || {},
        this.methodInfoGetAlternateSchedule,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetAlternateSchedule',
    request,
    metadata || {},
    this.methodInfoGetAlternateSchedule);
  }

  methodInfoSetAlternateSchedule = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: SetAlternateScheduleRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  setAlternateSchedule(
    request: SetAlternateScheduleRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  setAlternateSchedule(
    request: SetAlternateScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  setAlternateSchedule(
    request: SetAlternateScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/SetAlternateSchedule',
        request,
        metadata || {},
        this.methodInfoSetAlternateSchedule,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/SetAlternateSchedule',
    request,
    metadata || {},
    this.methodInfoSetAlternateSchedule);
  }

  methodInfoRemoveAlternateSchedule = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: RemoveRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  removeAlternateSchedule(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  removeAlternateSchedule(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  removeAlternateSchedule(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/RemoveAlternateSchedule',
        request,
        metadata || {},
        this.methodInfoRemoveAlternateSchedule,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/RemoveAlternateSchedule',
    request,
    metadata || {},
    this.methodInfoRemoveAlternateSchedule);
  }

  methodInfoSetCancellation = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: RemoveRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  setCancellation(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  setCancellation(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  setCancellation(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/SetCancellation',
        request,
        metadata || {},
        this.methodInfoSetCancellation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/SetCancellation',
    request,
    metadata || {},
    this.methodInfoSetCancellation);
  }

  methodInfoRemoveCancellation = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.EmptyOrErrorResponse,
    (request: RemoveRequest) => {
      return request.serializeBinary();
    },
    shared_pb.EmptyOrErrorResponse.deserializeBinary
  );

  removeCancellation(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.EmptyOrErrorResponse>;

  removeCancellation(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void): grpcWeb.ClientReadableStream<shared_pb.EmptyOrErrorResponse>;

  removeCancellation(
    request: RemoveRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.EmptyOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/RemoveCancellation',
        request,
        metadata || {},
        this.methodInfoRemoveCancellation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/RemoveCancellation',
    request,
    metadata || {},
    this.methodInfoRemoveCancellation);
  }

  methodInfoGetOperatingAreaDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    OperatingAreasOrErrorResponse,
    (request: OperatingAreasRequest) => {
      return request.serializeBinary();
    },
    OperatingAreasOrErrorResponse.deserializeBinary
  );

  getOperatingAreaDetails(
    request: OperatingAreasRequest,
    metadata: grpcWeb.Metadata | null): Promise<OperatingAreasOrErrorResponse>;

  getOperatingAreaDetails(
    request: OperatingAreasRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: OperatingAreasOrErrorResponse) => void): grpcWeb.ClientReadableStream<OperatingAreasOrErrorResponse>;

  getOperatingAreaDetails(
    request: OperatingAreasRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: OperatingAreasOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetOperatingAreaDetails',
        request,
        metadata || {},
        this.methodInfoGetOperatingAreaDetails,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetOperatingAreaDetails',
    request,
    metadata || {},
    this.methodInfoGetOperatingAreaDetails);
  }

  methodInfoGetOperatingAreaAbbrevDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    OperatingAreasOrErrorResponse,
    (request: OperatingAreasAbbrevRequest) => {
      return request.serializeBinary();
    },
    OperatingAreasOrErrorResponse.deserializeBinary
  );

  getOperatingAreaAbbrevDetails(
    request: OperatingAreasAbbrevRequest,
    metadata: grpcWeb.Metadata | null): Promise<OperatingAreasOrErrorResponse>;

  getOperatingAreaAbbrevDetails(
    request: OperatingAreasAbbrevRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: OperatingAreasOrErrorResponse) => void): grpcWeb.ClientReadableStream<OperatingAreasOrErrorResponse>;

  getOperatingAreaAbbrevDetails(
    request: OperatingAreasAbbrevRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: OperatingAreasOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetOperatingAreaAbbrevDetails',
        request,
        metadata || {},
        this.methodInfoGetOperatingAreaAbbrevDetails,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetOperatingAreaAbbrevDetails',
    request,
    metadata || {},
    this.methodInfoGetOperatingAreaAbbrevDetails);
  }

  methodInfoGetAllOperatingAreaDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    OperatingAreasOrErrorResponse,
    (request: shared_pb.Empty) => {
      return request.serializeBinary();
    },
    OperatingAreasOrErrorResponse.deserializeBinary
  );

  getAllOperatingAreaDetails(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<OperatingAreasOrErrorResponse>;

  getAllOperatingAreaDetails(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: OperatingAreasOrErrorResponse) => void): grpcWeb.ClientReadableStream<OperatingAreasOrErrorResponse>;

  getAllOperatingAreaDetails(
    request: shared_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: OperatingAreasOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetAllOperatingAreaDetails',
        request,
        metadata || {},
        this.methodInfoGetAllOperatingAreaDetails,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetAllOperatingAreaDetails',
    request,
    metadata || {},
    this.methodInfoGetAllOperatingAreaDetails);
  }

  methodInfoGetLastTimeSlot = new grpcWeb.AbstractClientBase.MethodInfo(
    GetLastTimeSlotOrErrorResponse,
    (request: OperatingAreaScheduleRequest) => {
      return request.serializeBinary();
    },
    GetLastTimeSlotOrErrorResponse.deserializeBinary
  );

  getLastTimeSlot(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null): Promise<GetLastTimeSlotOrErrorResponse>;

  getLastTimeSlot(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetLastTimeSlotOrErrorResponse) => void): grpcWeb.ClientReadableStream<GetLastTimeSlotOrErrorResponse>;

  getLastTimeSlot(
    request: OperatingAreaScheduleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: GetLastTimeSlotOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/GetLastTimeSlot',
        request,
        metadata || {},
        this.methodInfoGetLastTimeSlot,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/GetLastTimeSlot',
    request,
    metadata || {},
    this.methodInfoGetLastTimeSlot);
  }

  methodInfoUpdateSiteDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    OperatingAreaDetails,
    (request: OperatingAreaDetails) => {
      return request.serializeBinary();
    },
    OperatingAreaDetails.deserializeBinary
  );

  updateSiteDetails(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null): Promise<OperatingAreaDetails>;

  updateSiteDetails(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: OperatingAreaDetails) => void): grpcWeb.ClientReadableStream<OperatingAreaDetails>;

  updateSiteDetails(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: OperatingAreaDetails) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/UpdateSiteDetails',
        request,
        metadata || {},
        this.methodInfoUpdateSiteDetails,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/UpdateSiteDetails',
    request,
    metadata || {},
    this.methodInfoUpdateSiteDetails);
  }

  methodInfoCreateSite = new grpcWeb.AbstractClientBase.MethodInfo(
    OperatingAreaDetails,
    (request: OperatingAreaDetails) => {
      return request.serializeBinary();
    },
    OperatingAreaDetails.deserializeBinary
  );

  createSite(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null): Promise<OperatingAreaDetails>;

  createSite(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: OperatingAreaDetails) => void): grpcWeb.ClientReadableStream<OperatingAreaDetails>;

  createSite(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: OperatingAreaDetails) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/CreateSite',
        request,
        metadata || {},
        this.methodInfoCreateSite,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/CreateSite',
    request,
    metadata || {},
    this.methodInfoCreateSite);
  }

  methodInfoDeleteEmptySite = new grpcWeb.AbstractClientBase.MethodInfo(
    shared_pb.Empty,
    (request: OperatingAreaDetails) => {
      return request.serializeBinary();
    },
    shared_pb.Empty.deserializeBinary
  );

  deleteEmptySite(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null): Promise<shared_pb.Empty>;

  deleteEmptySite(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: shared_pb.Empty) => void): grpcWeb.ClientReadableStream<shared_pb.Empty>;

  deleteEmptySite(
    request: OperatingAreaDetails,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: shared_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.SiteService/DeleteEmptySite',
        request,
        metadata || {},
        this.methodInfoDeleteEmptySite,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.SiteService/DeleteEmptySite',
    request,
    metadata || {},
    this.methodInfoDeleteEmptySite);
  }

  methodInfoGetSiteWeather = new grpcWeb.AbstractClientBase.MethodInfo(
    SiteWeatherForecast,
    (request: OperatingAreasRequest) => {
      return request.serializeBinary();
    },
    SiteWeatherForecast.deserializeBinary
  );

  getSiteWeather(
    request: OperatingAreasRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/fleet.SiteService/GetSiteWeather',
      request,
      metadata || {},
      this.methodInfoGetSiteWeather);
  }

  methodInfoGetSiteWeatherMap = new grpcWeb.AbstractClientBase.MethodInfo(
    SiteWeatherMap,
    (request: SiteWeatherMap) => {
      return request.serializeBinary();
    },
    SiteWeatherMap.deserializeBinary
  );

  getSiteWeatherMap(
    request: SiteWeatherMap,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/fleet.SiteService/GetSiteWeatherMap',
      request,
      metadata || {},
      this.methodInfoGetSiteWeatherMap);
  }

}

